import { createFileRoute } from "@tanstack/react-router";
import { SikkerhedstjekLandingPage, FAQ } from "@/pages/SikkerhedstjekLandingPage";
import { BASE_URL } from "@/i18n/head";

const URL = BASE_URL + "/gratis-sikkerhedstjek-landing";
const TITLE = "Gratis sikkerhedstjek af byggepladsen | MI Support";
const DESCRIPTION =
  "Få et gratis og uforpligtende sikkerhedstjek af jeres byggeplads. En HSE-specialist gennemgår pladsen, og I får en rapport med konkrete forbedringer.";
const OG_IMAGE = BASE_URL + "/wp-content/uploads/Dan-Container3_1350x900-scaled-1.jpg";

export const Route = createFileRoute("/gratis-sikkerhedstjek-landing")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: URL },
      {
        rel: "preload",
        as: "image",
        href: "/wp-content/uploads/Dan-Container3_1350x900-scaled-1.jpg",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: SikkerhedstjekLandingPage,
});
